import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import { ConfigProvider } from 'antd';
import store from './redux/store'
import App from './App'
import zhCN from 'antd/es/locale/zh_CN';
import appHoc from "./components/hoc/appHoc";
const AppHoc = appHoc(App)
ReactDOM.render(
    (
        <Provider store={store}>
            <ConfigProvider locale={zhCN}>
                <AppHoc />
            </ConfigProvider>
        </Provider>
    ),
    document.getElementById('root')
)

